<template>
  <FontAwesomeIcon
    ref="iconRef"
    icon="info-circle"
    @click="showTooltip = !showTooltip"
    class="text-inherit outline-none transition-all duration-300 hover:text-primary whitespace-pre"
    v-tooltip="{content: tooltip, placement: position, shown: showTooltip}"
    :size="iconSize"
  />
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { onClickOutside } from '@vueuse/core'

interface IProps {
  tooltip: string
  position?: string
  iconSize?: 'xs' | 'sm' | 'lg'
}

withDefaults(defineProps<IProps>(), {
  position: 'top',
  iconSize: 'sm'
})

const showTooltip = ref(false)
const iconRef = ref<HTMLElement | null>(null)

onClickOutside(iconRef, () => {
  showTooltip.value = false
})
</script>

<style scoped lang="scss">

</style>